module.exports = __webpack_public_path__ + "assets/img/chronicleImg-eaccac24.png";